import { action, makeObservable, observable } from 'mobx';

import type { ChangeDistanceDetails } from 'src/modules/changeDistance/types';

export class ChangeDistanceStore {
  @observable
  token: string | nil;
  @observable
  details: ChangeDistanceDetails | null = null;
  @observable
  errorCode: string | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  setToken(token: string): void {
    this.token = token;
  }

  @action
  setDetails(details: ChangeDistanceDetails): void {
    this.details = details;
    this.errorCode = null;
  }

  @action
  setError(errorCode: string): void {
    this.details = null;
    this.errorCode = errorCode;
  }

  @action
  clean(): void {
    this.token = null;
    this.details = null;
    this.errorCode = null;
  }
}
